import { curityAuthParams } from 'consts/curity';
import { expirationTime, type FormValues, isLogged, tokenData } from 'helpers';
import type { AppCtx } from 'providers/AppContext';
import { userAction } from 'store/actions';
import { buildUserState, type UserState } from 'store/state';

export function handleUserForm(ctx: AppCtx, formValues: FormValues) {
	const { config, entityType, flowType, dispatch } = ctx;
	const { CURITY_AUTHORIZATION_URL, CURITY_CLIENT_ID, IS_EMPLOYEE_WEB } = config;
	const user = { ...buildUserState(), ...formValues, entityType, flowType, exp: expirationTime() };
	dispatch([userAction, { user }]);
	if (IS_EMPLOYEE_WEB) {
		const qs = new URLSearchParams(curityAuthParams(CURITY_CLIENT_ID));
		globalThis.location.href = `${CURITY_AUTHORIZATION_URL}?${qs}`;
	} else {
		authenticateUser(ctx, formValues, user);
	}
}

function authenticateUser(ctx: AppCtx, formValues: FormValues, userState: UserState) {
	const { config, dispatch, http, t } = ctx;
	const msg = t('authentication_loading_text', 'authentication');
	http.post(config.API.authenticate, formValues, msg).then((res: { token?: string }) => {
		if (res?.token) {
			const token = tokenData(res.token);
			if (token) {
				const user = {
					email: token.email ?? userState.email,
					exp: token.exp,
					givenName: token.given_name,
					kennitala: token.sub,
					phone: token.phone_number ?? userState.phone,
					token: res.token
				} as UserState;
				if (isLogged(user)) {
					dispatch([userAction, { user }]);
					const ms = (user.exp - Math.floor(Date.now() / 1000)) * 1000;
					setTimeout(() => dispatch([userAction, { user: buildUserState() }]), ms);
				}
			}
		}
	});
}
